/**
 *  自定义控件书写模板
 */
(function (KDApi, $) {
  // 构造函数，变量名随意，与最后一句代码的KDApi.register的第二个参数一致即可
    function LangSwitch(model) {
        this._setModel(model)
    }
    const mockData = [
        {
            "id": "lang_zh_cn",
            "text": {
                "zh_CN": "简体中文"
            },
            "isSelected": true
        }
    ]
    const _this = {}

    function getPosition () {
        const icon = document.getElementById('kd-custom-lang');
        const iconRect = icon.getBoundingClientRect();
        return {
            top: iconRect.top,
            right: iconRect.right
        }
    }

    function setDropDownPosition () {
        const dropdown = document.getElementById('kd-custom-lang-dropdown');
        const offsetTop = 10;
        const selfHeight = 14;
        const pos = getPosition();
        dropdown.classList.add("kd-custom-lang-dropdown");
        dropdown.style.top = pos.top + selfHeight + offsetTop + "px";
        dropdown.style.right = window.innerWidth - pos.right + "px"
    }

    function isInteger (obj) {
        return obj%1 === 0
    }

    function onClick (event, model, data) {
        const dataKey = parseInt(event.target.dataset.key);
        let key
        if(data instanceof Array && isInteger(dataKey)){
            key = data[dataKey]?.id;
            invokeService(model, "click", { key: key });
            event.stopPropagation();
            hideDropdown();
        }
        event.stopPropagation();
    }

    function toggleDropdown () {
        const dropdown = document.getElementById('kd-custom-lang-dropdown');
        const dropdownShow = dropdown.classList.contains("kd-custom-lang-dropdown-show");
        dropdownShow ? hideDropdown() : showDropdown();
    }

    function hideDropdown () {
        const dropdown = document.getElementById('kd-custom-lang-dropdown');
        dropdown.classList.remove("kd-custom-lang-dropdown-show");
        window.removeEventListener("click", clickOutSide, true);
        window.removeEventListener("resize", setDropDownPosition)
    }

    function showDropdown () {
        const dropdown = document.getElementById('kd-custom-lang-dropdown');
        setDropDownPosition() // 隐藏时窗口resize
        dropdown.classList.add("kd-custom-lang-dropdown-show");
        window.addEventListener("click", clickOutSide, true);
        window.addEventListener("resize", setDropDownPosition)
    }

    function addDropdownItemEventListner () {
        const dropdown = document.getElementById('kd-custom-lang-dropdown');
        dropdown.addEventListener("click", function (e) { onClick(e, _this.model, _this.props.data || []) }, true)
    }
    
    function removeDropdownItemEventListner () {
        const dropdown = document.getElementById('kd-custom-lang-dropdown');
        dropdown.removeEventListener("click", function (e) { onClick(e, _this.model, _this.props.data || []) }, true)
    }


    function clickOutSide (e) {
        const dropdown = document.getElementById('kd-custom-lang-dropdown');
        const lang = document.getElementById('kd-custom-lang');
        const dialogDom = document.querySelector('#dialogShow') // 判断内容选择弹出层是否存在
        const targetDom = event.target
        let clickInSideslippingFlex = false
        const isNotificationDom = document.getElementById('kd-notification')?.contains(targetDom)
        const isSysNotificationDom = document.getElementById('system-notification')?.contains(targetDom)
        if (dialogDom || isNotificationDom || isSysNotificationDom) {
            clickInSideslippingFlex = true
        }
        if (clickInSideslippingFlex) return
        if (!dropdown.contains(e.target) && !lang.contains(e.target)) {
            hideDropdown();
            e.stopPropagation()
        }
    }

    function addButtonEvent () {
        const langEle = document.getElementById('kd-custom-lang');
        langEle.onclick = function (e) {
            e.stopPropagation()
            toggleDropdown()
        }
    }

    function addButtonTitle (title) {
        const langEle = document.getElementById('kd-custom-lang');
        if(!langEle || !title) return
        langEle.title = title
    }

    function createULElement () {
        const ul = document.createElement("ul")
        ul.id = 'kd-custom-lang-dropdown'
        ul.classList.add('kd-custom-lang-dropdown')
        document.body.appendChild(ul)
    }

    function clearDropdownItems () {
        const dropdown = document.getElementById('kd-custom-lang-dropdown');
        if(dropdown) {
            dropdown.innerHTML = ''
        }
    }

    function createDropdownElement (props, lang) {
        createULElement()
        createDropdownItems(props, lang)
    }

    function updateDropdownItems (props, lang) {
        clearDropdownItems()
        createDropdownItems(props, lang)
    }

    function createDropdownItems (props, lang) {
        const dropdown = document.getElementById('kd-custom-lang-dropdown');
        if(!dropdown) return
        if (props.data instanceof Array) {
            const fragment = document.createDocumentFragment();
            props.data.forEach(function (item, index) {
                const textLang = item['text'][lang] || Object.values(item['text'])[0]
                const li = document.createElement('li');
                if(item.isSelected) {
                    li.classList.add("kd-custom-lang-dropdown-item-selected")
                }
                li.classList.add("kd-custom-lang-dropdown-item")
                li.innerHTML = textLang;
                li.title = textLang;
                li.setAttribute("data-key", index)
                fragment.appendChild(li);
            })
            dropdown.appendChild(fragment);
            setDropDownPosition();
        }
    }

    function invokeService (model, methodName, args) {
        model.invokeAsync(methodName, args)
    }

    // 原型中封装生命周期函数，固定格式
    LangSwitch.prototype = {
        _setModel: function (model) {
        this.model = model
        },
        init: function (props) {
        // TO DO
            _this.model = this.model
            _this.props = props
            initFunc()
        },
        update: function (props) {
        // TO DO
            _this.model = this.model
            _this.props = props
            const title = _this.model.metaData['title']
            addButtonTitle(title)
            updateDropdownItems(_this.props, _this.props.lang || "zh_CN")
        },
        destoryed: function () {
            window.removeEventListener("click", clickOutSide, true)
            removeDropdownItemEventListner()
            _this.model = null
            _this.props  = null
        }
    }

    // Other Code
    const initFunc = function () {
        // props.data = props.data || []
        window.KDApi.getTemplateStringByFilePath('./html/langSwitch.html', _this.model).then(function (result) {
            window.KDApi.loadFile('./css/index.css', _this.model, function () {
                _this.model.dom.innerHTML = result
                const title = _this.model.metaData['title']
                addButtonEvent()
                addButtonTitle(title)
                createDropdownElement(_this.props, _this.props.lang || "zh_CN")
                addDropdownItemEventListner()
            })
        })
    }

  // 你只需知道第一个参数是你接下来要新增控件方案时填的方案id，第二个参数是上面声明的构造函数
  KDApi.register('langswitch', LangSwitch)
})(window.KDApi, jQuery) // 这里的jQuery不是必须要传进去的，可移除，要用到的时候才传，PC端系统默认会有jQuery对象，版本是1.12.4